var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"tp-1-txt align_heading"},[_vm._v("Please Tell Us About Your Auto")]),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('form-section',{staticClass:"formSection",attrs:{"number":"2","title":"Auto Features"}},[(_vm.features)?_c('div',{staticClass:"md-gutter mt-4 md-alignment-center-left mb_mt_5",staticStyle:{"display":"block","margin":"0 auto"}},[_vm._l((_vm.features),function(feature,index){return _c('input-component',{key:index,staticClass:"mb_mt_5 mt-4",staticStyle:{"margin":"0 auto","max-width":"376px"},attrs:{"label":feature.key.replaceAll('_', ' '),"custom":"true","size":33}},[_c('v-select',{staticClass:"dropdown",attrs:{"options":feature.values,"placeholder":_vm.CombinesStrings('Select ', feature.key),"taggable":"","push-tags":""},model:{value:(_vm.form[("" + (feature.key))]),callback:function ($$v) {_vm.$set(_vm.form, ("" + (feature.key)), $$v)},expression:"form[`${feature.key}`]"}})],1)}),_vm._v(" "),_c('router-link',{staticClass:"btn-next",staticStyle:{"width":"74%","display":"block","margin":"0 auto"},attrs:{"exact":"","to":{
          path: '/dashboard/vendor/addAuto/',
          query: {
            market_type: _vm.$route.query.market_type,
            category: _vm.$route.query.category,
            name: _vm.$route.query.name,
            type: _vm.$route.query.type,
            kilometers: _vm.$route.query.kilometers,
            purpose: _vm.$route.query.purpose,
            brand: _vm.$route.query.brand,
            model: _vm.$route.query.model,
            body_type: _vm.form.body_type,
            doors: _vm.form.doors,
            cylinders: _vm.form.cylinders,
            horsepower: _vm.form.horsepower,
            transmission_type: _vm.form.transmission_type,
            color: _vm.form.color,
            warranty: _vm.form.warranty,
            fuel_type: _vm.form.fuel_type,
            regional_specs: _vm.form.regional_specs,
            body_condition: _vm.form.body_condition,
            mechanical_condition: _vm.form.mechanical_condition,
            length: _vm.form.length,
            capacity: _vm.form.capacity,
            wheels: _vm.form.wheels,
            engine_size: _vm.form.engine_size,
            drive_system: _vm.form.drive_system,
          },
        }}},[_c('button',{staticClass:"button primary block submit w-100 mt-5",attrs:{"id":"carDetailSubmit"}},[_vm._v("\n          Next\n        ")])])],2):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2248138d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/profileDashboard/vendor/auto/autoSubCategory.vue
// module id = null
// module chunks = 